import { SHORTCUT_KEY_MAPPER } from '@/constant';

import { VFlex } from '../VFlex';
import { useVContextMenuContext } from './hook';
import type { VContextMenuItemProps } from './type';

export const VContextMenuItem = ({
  children,
  disabled,
  shortcut,

  onClick,
}: React.PropsWithChildren<VContextMenuItemProps>) => {
  const { isMacOS, style } = useVContextMenuContext();
  const displayedShortcut =
    shortcut
      ?.split('+')
      .map(v => {
        const key = v.trim().toLowerCase();
        const hasKey =
          SHORTCUT_KEY_MAPPER[key as keyof typeof SHORTCUT_KEY_MAPPER];
        let displayedKey = key;

        if (hasKey) {
          displayedKey = hasKey[isMacOS ? 'MacOS' : 'Windows'];
        }

        return displayedKey;
      })
      .join('+') ?? '';

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();

    if (disabled) return;

    onClick?.(e);
  };

  return (
    <VFlex
      aria-disabled={disabled}
      aria-label="v-context-menu-item"
      className={style.item}
      role="menuitem"
      onClick={handleClick}
    >
      <div aria-label="v-context-menu-item-label">{children}</div>
      {shortcut && (
        <VFlex aria-label="v-context-menu-item-shortcut" gap={0.1875}>
          {displayedShortcut}
        </VFlex>
      )}
    </VFlex>
  );
};

VContextMenuItem.displayName = 'VContextMenuItem';
